export default __webpack_public_path__ + "static/media/catalog-detail.cf0cb44b.jpeg";